export const DARK_THEME = "dim";
export const LIGHT_THEME = "cozy";
